// extracted by mini-css-extract-plugin
export default {"layout":"admin-layout_layout__Ir49-","layoutHeader":"admin-layout_layoutHeader__ZH1Kn","layoutSidebar":"admin-layout_layoutSidebar__qmCh+"};